<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8">
    <div class=" overflow-hidden">
      <CentralHeader
        title="SUBSCRIBE FOR UGM UPDATES"
        class="mt-12"
        subtitle=""
      ></CentralHeader>
      <div class="mt-10">
        <Card class="bg-grey">
          <div
            class="mt-0 md:mt-6 lg:mt-12 p-4 flex flex-col space-y-6 md:space-y-0 justify-around
              lg:px-20
           "
          >
            <div class="mb-6">
              <!-- EMAIL -->
              <div class="l-form-default" style="padding-bottom: 2rem; padding-top: 0;width: 80%;margin: 0 auto;">
                <div class="sc-ckVGcZ jslhpj"><h1 class="sc-jKJlTe jmtkzV">Sign up for UGM updates</h1></div>
                <div class="sc-bdVaJa iIDDUy">
                  <form class="js-cm-form" id="subForm" action="https://www.createsend.com/t/subscribeerror?description=" method="post" data-id="5B5E7037DA78A748374AD499497E309EE7597E6A8B3DE5CEF82D6F42828C9519CD316A67D76AF6E3110F7EFB84AB6394B6BEBE62CA6FB20FB8D9A70C701A71B4">
                    <div class="sc-cSHVUG jZSLFe">
                      <div class="sc-cSHVUG kXIIFK">
                        <div>
                          <label for="fieldName" class="sc-gzVnrw hYNtOw">Name </label>
                          <input id="fieldName" maxLength="200" name="cm-name" placeholder="Your name" class="sc-gZMcBi dshyOS" />
                        </div>
                      </div>
                      <div class="sc-cSHVUG kXIIFK">
                        <div>
                          <label for="fieldEmail" class="sc-gzVnrw cKFCFj">Email <span class="sc-dnqmqq iFTUZ">*</span></label>
                          <input autoComplete="Email" id="fieldEmail" maxLength="200" name="cm-nyuuka-nyuuka" placeholder="Your email" required type="email" class="js-cm-email-input qa-input-email sc-gZMcBi dshyOS" />
                        </div>
                      </div>
                      <div class="sc-cSHVUG kXIIFK">
                        <div>
                          <label for="fielddhulhyil" class="sc-gzVnrw gWbZOQ">Country &amp; State </label>
                          <input id="fielddhulhyil" maxLength="200" name="cm-f-dhulhyil" class="sc-gZMcBi dshyOS" />
                        </div>
                      </div>
                      <div class="sc-cSHVUG jZSLFe">
                        <div>
                          <div spacing="x-small" class="sc-iAyFgw coBuPy"></div>
                          <div class="sc-cSHVUG jZSLFe">
                            <div>
                              <div>
                                <div class="sc-bwzfXH ebeRtN">
                                  <input aria-required id="cm-privacy-consent" name="cm-privacy-consent" required type="checkbox" class="qa-checkbox-cm-privacy-consent sc-bZQynM eKOoKL" />
                                  <label for="cm-privacy-consent" class="sc-bxivhb fiUAra">Agree to Marketing emails</label>
                                  <div id="cm-privacy-consent-required-label" class="sc-EHOje jMsntP">*</div>
                                </div>
                              </div>
                              <input id="cm-privacy-consent-hidden" name="cm-privacy-consent-hidden" type="hidden" value="true" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button type="submit" class="js-cm-submit-button sc-brqgnP dwYSlG">Subscribe</button>
                  </form>
                </div>
                </div>


              <!-- END EMAIL -->

            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js"></script>
<script>
import WebFont from "autoprefixer/lib/prefixer";
WebFont.load({google:{families:['Lato:900:latin']}});</script>
<!--<script type="text/javascript" src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"></script>-->

<script lang="js">

import CentralHeader from "../components/shared/CentralHeader";
import Card from "../components/shared/Card.vue";

export default {
  name: "Purchase",
  components: {
    Card,
    CentralHeader
  },
  /*mounted() {
    this.initializeFS();
  },
  methods: {
    initializeFS() {
      let customerDetails = {
        "reset": true,
        "tags": {
          route: "onlineUserGroupMeeting"
        }
      };

      // eslint-disable-next-line no-undef
      fastspring.builder.push(customerDetails);
    },
  }*/

  mounted() {
    const script = document.createElement("script");
    script.src =
        "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js";
    script.onload = () => {
    };
    document.head.appendChild(script);
  },

};
</script>

<style scoped>
.container-gradient {
  background-image: linear-gradient(
    160deg,
    theme("colors.white"),
    theme("colors.lighterblue")
  );
}

.venue {
  top: -12px;
}

.bg-grey {
  background: #ededed;
}

.bg-largeListTick {
  background-image: url("../assets/tick-yellow-black.svg");
  background-size: 24px 24px;
}

.topminus {
  top: -2px;
}

.iIDDUy { background: rgb(255, 255, 255); padding: 2.5rem 2.75rem; }
.ebeRtN { align-items: flex-start; display: flex; }
.fiUAra { font-size: 0.875rem; padding-left: 0.5rem; overflow-wrap: break-word; word-break: break-word; font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(67, 77, 93); position: relative; top: 2px; }
.jMsntP { color: rgb(221, 54, 42); font-weight: 400; font-size: 0.75rem; margin-left: 0.125rem; }
.eKOoKL { flex-shrink: 0; height: 1rem; position: relative; top: 0.08rem; width: 1rem; }
.hYNtOw { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }
.cKFCFj { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }
.gWbZOQ { font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(93, 93, 101); display: block; font-size: 0.875rem; }
.iFTUZ { color: rgb(221, 54, 42); }
.dshyOS { appearance: none; background-color: rgb(255, 255, 255); box-shadow: rgba(142, 154, 173, 0.1) 0px 2px 0px 0px inset, rgb(210, 215, 223) 0px 0px 0px 1px inset, rgb(255, 255, 255) 0px 1px 0px 0px; color: rgb(67, 77, 93); font-size: 0.875rem; line-height: 1.5; min-height: 2.8125rem; outline: 0px; padding: 0.75rem 1rem; transition: box-shadow 0.2s; width: 100%; }
.dshyOS:focus { box-shadow: transparent 0px 0px 0px 0px inset, rgb(80, 156, 246) 0px 0px 0px 1px inset, rgba(80, 156, 246, 0.25) 0px 0px 0px 2px; }
.jZSLFe { margin-bottom: 1.5rem; }.kXIIFK { margin-bottom: 1rem; }.jslhpj { margin-left: auto; margin-right: auto; max-width: 29.125rem; padding-bottom: 3.125rem; }
.jmtkzV { font-size: 2rem; text-align: center; letter-spacing: -1px; line-height: 1; -webkit-font-smoothing: antialiased; font-family: Lato, Arial, sans-serif; font-weight: 900; color: rgb(0, 0, 0); }
.kFBOaz { border-bottom: 1px solid rgb(210, 215, 223); margin-bottom: 1.5rem; padding-top: 1.5rem; }
.coBuPy { border-bottom: 1px solid rgb(210, 215, 223); margin-bottom: 0.75rem; padding-top: 0.75rem; }
.cVhqQi { margin-bottom: 0.25rem; }@-webkit-keyframes iECmZH {   0% { transform: rotate(0deg); }  100% { transform: rotate(360deg); }}@keyframes iECmZH {   0% { transform: rotate(0deg); }  100% { transform: rotate(360deg); }}
.dwYSlG { background-color: rgb(123, 177, 61); border-radius: 3px; color: rgb(255, 255, 255); display: inline-block; font-family: Helvetica, Arial, sans-serif; font-weight: 400; font-size: 1rem; line-height: 1; outline: 0px; padding: 0.75rem 1.5rem; text-decoration: none; transition: background-color 0.1s ease-in, box-shadow 0.1s ease-in; }
.dwYSlG:hover { cursor: pointer; }
.hRybD { white-space: pre-wrap; font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: 400; color: rgb(67, 77, 93); }
a, abbr, address, article, aside, b, blockquote, body, caption, cite, code, dd, details, dialog, div, dl, dt, em, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, html, i, iframe, img, label, legend, li, main, menu, nav, object, ol, p, pre, section, small, span, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, u, ul { /*border: 0px; margin: 0px; padding: 0px;*/ }
*, ::after, ::before { box-sizing: inherit; }
html { font-family: "Helvetica Neue", Arial, sans-serif; font-size: 16px; }
h1, h2, h3, h4, h5, h6, html { color: rgb(67, 77, 93); font-weight: 400; line-height: 1.5; }
a { color: rgb(25, 169, 229); text-decoration: underline; }
button, label, p { overflow-wrap: break-word; word-break: break-word; }
</style>
